import Methods from "../methods";

const saveRangeBox = (context, params, payload) => {
  const url = `api/rangeBox/save?${params}`;
  return Methods.doPost(context, url, payload);
}

const listRangeBox = (context, idOrder) => {
  const url = `api/rangeBox/${idOrder}`;
  return Methods.doGet(context, url, null);
}

const listRangeBoxByOrder = (context, idOrder) => {
  if (!idOrder) {
    console.error("idOrder es obligatorio para listar RangeBox");
    return Promise.reject(new Error("idOrder es obligatorio"));
  }

  const url = `api/rangeBox/${idOrder}`;
  return Methods.doGet(context, url, null);
};

export default {
  saveRangeBox,
  listRangeBox,
  listRangeBoxByOrder
}



// WEBPACK FOOTER //
// ./src/api/modules/RangeBoxGeneralApi.js